import React from "react";
import PropTypes from 'prop-types';
import { PrimaryButton, HorizontalSeparator, SeparatorWithTitle } from "../..";
import { WHITE, GREY_GAME_EVENT_DIVIDER, GREEN_LIGHT } from '../../styles/shared/colors';
import "./FilterCategory.scss";

const FilterCategory = ({ category, hasSeparator, onItemClick, categoryName, currentCategoryFilter }) => {

  return (
    <div className="filter-category">
      <SeparatorWithTitle title={categoryName}/>
      {category.map(item =>
        <PrimaryButton
          key={item}
          color={WHITE}
          background={currentCategoryFilter.includes(item) ? GREEN_LIGHT : GREY_GAME_EVENT_DIVIDER}
          onClick={()=> onItemClick(item, categoryName)}
        >
          {categoryName === 'periods'? `Period ${item}` : item}
        </PrimaryButton>)}
      {/* {hasSeparator && <HorizontalSeparator />} */}
    </div>
  );
};

FilterCategory.propTypes = {
  category: PropTypes.array,
  hasSeparator: PropTypes.bool
};

FilterCategory.defaultProps = {
  category: [],
  hasSeparator: false
};

export default FilterCategory;
